export const TEST_ID = 'sameAiWarningBanner';

// A row contributes to the banner only when 2+ products share the same CAS.
export const MIN_CONTRIBUTIONS_FOR_STACKING = 2;

export const LB_AI_DECIMAL_PRECISION = 3;
